import Image from "next/image";

import { cn } from "@/lib/utils";

const logoAssets = {
  default: { src: "/img/obanker-logo.png", width: 993, height: 250 },
  metal: { src: "/img/obanker-logo-metal.png", width: 968, height: 223 },
} as const;

type BrandLogoProps = {
  className?: string;
  inverted?: boolean;
  priority?: boolean;
  variant?: keyof typeof logoAssets;
};

export function BrandLogo({
  className,
  inverted = false,
  priority = false,
  variant = "default",
}: BrandLogoProps) {
  const asset = logoAssets[variant];

  return (
    <Image
      src={asset.src}
      alt="OBANKER"
      width={asset.width}
      height={asset.height}
      priority={priority}
      suppressHydrationWarning
      className={cn(
        "h-8 w-auto max-w-[180px] object-contain object-left",
        inverted && "brightness-0 invert",
        className,
      )}
    />
  );
}
